import { useEffect } from 'react'

import { getCable } from './cable'

export type ChatroomPayload = {
  chatroomId: string
  message: {
    id: string
    content: string
    createdAt: string
    senderType: 'Player' | 'SchoolCoach' | 'TeamCoach'
    senderName: string
  }
}

type Handler = (payload: ChatroomPayload) => void

export function useChatroomChannel(chatroomId: string, handler: Handler) {
  useEffect(() => {
    if (!chatroomId) return

    const subscription = getCable().subscriptions.create(
      { channel: 'ChatroomChannel', chatroom_id: chatroomId },
      {
        received: (data: ChatroomPayload) => {
          if (data.chatroomId === chatroomId) {
            handler(data)
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [chatroomId, handler])
}
